import React from 'react';

import { ROUTES } from '~constants/routes';

import LegacyRouteRedirect from './LegacyRouteRedirect';

const ClientLaborRedirect = () => <LegacyRouteRedirect to={ROUTES.CLIENT_BIRTH_INFORMATION.path} />;

export default ClientLaborRedirect;
